enum Actions {
  UPDATE_PAYGRADES = 'updatePaygrades',
}

export default Actions;
